const create = (api) => {

  const listOrganization = (id) => {
    return api.get(`/organizations/${id}`)
  }

  const sendSubscriptionEmail = (data) => {
    return api.post(`/notifications/sendemail`, data)
  }

  const getCurrentUserEmailAddress = () => {
    return api.get(`/UserManagement/self`)
  }

  const addIdpConfig = (data) => {
    return api.post(`/idp-config`, data)
  }

  const getIdpConfig = () => {
    return api.get(`/idp-config`)
  }

  const putIdpConfigEnable = (id, data) => {
    return api.put(`/idp-config/${id}/status?enable=${data}`)
  }

  const getIdpConfigById = (id) => {
    return api.get(`/idp-config/${id}`)
  }

  const updateIdpConfig = (id,data) => {
    return api.put(`/idp-config/${id}`, data)
  }

  return {
    listOrganization,
    sendSubscriptionEmail,
    getCurrentUserEmailAddress,
    addIdpConfig,
    getIdpConfig,
    putIdpConfigEnable,
    getIdpConfigById,
    updateIdpConfig
  }

}

export default {
  create
}
